import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import TeacherDashboard from "./pages/TeacherDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import TeacherUploadVideo from "./pages/TeacherUploadVideo";
import TeacherEditVideo from "./pages/TeacherEditVideo";
import TeacherLayout from "./layouts/TeacherLayout";
import TeacherStudents from "./pages/TeacherStudents";
import TeacherTopic from "./pages/TeacherTopic";
import StudentRouter from "./pages/student/StudentRouter";
import StudentSelectClass from "./pages/student/StudentSelectClass";
import StudentSelectSubject from "./pages/student/StudentSelectSubject";
import StudentSelectTopic from "./pages/student/StudentSelectTopic";
import StudentSelectClassSSO from "./pages/student/StudentSelectClassSSO";
import StudentSelectSubjectSSO from "./pages/student/StudentSelectSubjectSSO";
import StudentSelectTopicSSO from "./pages/student/StudentSelectTopicSSO";
import StudentVideos from "./pages/student/StudentVideos";
import StudentWatch from "./pages/student/StudentWatch";
// import TeacherVideos from "./pages/TeacherVideos";


export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />

        <Route
          path="/admin"
          element={
            <ProtectedRoute allowed={["admin"]}>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/teacher"
          element={
            <ProtectedRoute allowed={["teacher"]}>
              <TeacherLayout>
                <TeacherDashboard />
              </TeacherLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/teacher/upload-video"
          element={
            <ProtectedRoute allowed={["teacher"]}>
              <TeacherLayout>
                <TeacherUploadVideo />
              </TeacherLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/teacher/edit-video/:id"
          element={
            <ProtectedRoute allowed={["teacher"]}>
              <TeacherLayout>
                <TeacherEditVideo />
              </TeacherLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/teacher/videos"
          element={
            <ProtectedRoute allowed={["teacher"]}>
              <TeacherLayout>
                <TeacherDashboard /> 
              </TeacherLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/teacher/topics"
          element={
            <ProtectedRoute allowed={["teacher"]}>
              <TeacherLayout>
                <TeacherTopic />
              </TeacherLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/teacher/students"
          element={
            <ProtectedRoute allowed={["teacher"]}>
              <TeacherLayout>
                <TeacherStudents />
              </TeacherLayout>
            </ProtectedRoute>
          }
        />

        {/* ---------------- STUDENT ROUTES ---------------- */}

        <Route
          path="/student"
          element={
            <ProtectedRoute allowed={["student"]}>
              <StudentRouter />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student/select-class"
          element={
            <ProtectedRoute allowed={["student"]}>
              <StudentSelectClass />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student/select-subject"
          element={
            <ProtectedRoute allowed={["student"]}>
              <StudentSelectSubject />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student/select-class-sso"
          element={
            <ProtectedRoute allowed={["student"]}>
              <StudentSelectClassSSO />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student/select-subject-sso"
          element={
            <ProtectedRoute allowed={["student"]}>
              <StudentSelectSubjectSSO />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student/select-topic"
          element={
            <ProtectedRoute allowed={["student"]}>
              <StudentSelectTopic />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student/select-topic-sso"
          element={
            <ProtectedRoute allowed={["student"]}>
              <StudentSelectTopicSSO />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student/videos"
          element={
            <ProtectedRoute allowed={["student"]}>
              <StudentVideos />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student/watch"
          element={
            <ProtectedRoute allowed={["student"]}>
              <StudentWatch />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
